import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { ToastService } from 'services/toast.service';
import { ClientCard, DeleteClientRequest } from 'types/client.interface';
import { MAX_LENGTH_TOPIC } from 'util/form.utility';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-delete-client',
  standalone: true,
  imports: [TranslateModule, FormsModule, SpinnerComponent, ReactiveFormsModule, NgClass, ConfirmModalComponent],
  templateUrl: './delete-client.component.html',
  styleUrls: ['../../form/base-form.scss', './delete-client.component.scss']
})
export class DeleteClientComponent extends BaseFormModalComponent implements OnInit {
  @Input() client!: ClientCard;
  @Output() save: EventEmitter<DeleteClientRequest> = new EventEmitter<DeleteClientRequest>();
  isConfirmModalOpen: boolean = false;

  get deleteReason(): AbstractControl<any, any> | null {
    return this.form.get('deleteReason');
  }

  get isDeletionBlocked(): boolean {
    return this.client?.canBeDeleted === false;
  }

  get blockReasonKey(): string {
    return this.client?.deletionBlockReason === 'ActiveInformationRequest'
      ? 'components.deleteClient.blockReasonActiveInformationRequest'
      : 'components.deleteClient.blockReasonDefault';
  }
  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit() {
    this.fillForm();
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      id: [this.client?.id],
      deleteReason: ['', [Validators.required, Validators.maxLength(MAX_LENGTH_TOPIC)]]
    });
  }

  handleSave() {
    if (this.form.valid) {
      this.isConfirmModalOpen = true;
    } else {
      this.submitAttempted = true;
      this.toastService.showDanger('validationError', '', {
        shouldTranslate: true
      });
    }
  }

  deleteClient(isConfirmed: boolean = false): void {
    if (!isConfirmed) {
      this.submitAttempted = false;
      this.isConfirmModalOpen = true;
    } else {
      if (this.form.valid) {
        this.submitAttempted = false;
        this.save.emit(this.form.getRawValue());
        this.close();
      } else {
        this.submitAttempted = true;
        this.toastService.showDanger('validationError', '', {
          shouldTranslate: true
        });
      }
    }
  }

  protected override close(): void {
    this.resetForm();
    super.close();
  }

  resetForm(): void {
    this.deleteReason?.setValue('');
    this.deleteReason?.markAsUntouched();
    this.deleteReason?.markAsPristine();
  }
}
